import { z } from 'zod';

export const userSchema = z.object({
  id: z.string().optional(),
  fullName: z.string(),
  email: z.string().email(),
  photoUrl: z.string().optional(),
  externalId: z.string().optional(),
  country: z.string().optional(),
  company: z.string().optional(),
  isInternal: z.boolean().optional()
});

export type UserType = z.infer<typeof userSchema>;

export const baseKpisSchema = z.object({
  format: z.string(),
  detentionSalesRate: z.number().optional(),
  averageWeeklySalesQuantity: z.number().optional(),
  averageWeeklySalesAmount: z.number().optional(),
  subFamily: z.string(),
  subFamilyAverageWeeklySalesQuantity: z.number().optional(),
  subFamilyAverageWeeklySalesAmount: z.number().optional(),
  salesAmount: z.number().optional(),
  salesAmountWithPromo: z.number().optional(),
  salesAmountWithoutPromo: z.number().optional(),
  salesQuantity: z.number().optional(),
  salesQuantityWithPromo: z.number().optional(),
  salesQuantityWithoutPromo: z.number().optional(),
  isInternal: z.boolean()
});

export const formatSchema = baseKpisSchema.extend({
  averageWeeklySalesQuantityGoal: z.number(),
  launchDate: z.date(),
  scopeStartDate: z.date()
});

const barcodeSchema = z.object({
  code: z.string(),
  codeWithLabel: z.string(),
  supplierName: z.string(),
  formats: z.array(formatSchema)
});

export const userWithGoalsAndKpisSchema = userSchema.extend({
  company: z.object({
    name: z.string()
  }),
  country: z.string(),
  barcodes: z.array(barcodeSchema),
  unknownEans: z.array(z.string())
});

export type UserWithGoalsAndKpisType = z.infer<typeof userWithGoalsAndKpisSchema>;
